<template>
  <div>
    <div class="btnitem" @click="inByLetDialogClick(item)">
      <img style="width:19px;height:19px" src="@/assets/linshiyonggong/hanxun@2x.png" />
      <span>函询</span>
    </div>
    <!-- 函询弹框 -->
    <InByLetDialog
      :dialogVisible="inByLetDialogShow"
      @closeDialog="
        v => {
          inByLetDialogShow = v
        }
      "
      @cancelDialog="
        v => {
          inByLetDialogShow = v
        }
      "
      @confirmDialog="confirminDialog"
    ></InByLetDialog>
  </div>
</template>

<script>
import { mapState } from "vuex"
import { apiResignAll } from "@/api/apiResignAll"
import { checkDataStatus } from "@/utils/checkDataStatus"
export default {
  name: "mail",
  props: {
    item: {
      type: Object,
      default() {
        return {}
      }
    },
    type: {
      type: [Number, String] // 1 工队 2 工程 3 工人 4 临时用工 5 工种报价 6劳务用工
    }
  },
  components: {
    InByLetDialog: () => import("@/components/public/InquiryLetterDialog") // 函询弹框
  },
  data() {
    return {
      inByLetDialogShow: false
    }
  },
  computed: {
    ...mapState({
      userNo: state => state.user.no,
      companyNo: state => state.user.companyNo
    })
  },
  methods: {
    //打开函询框
    async inByLetDialogClick(item) {
      if (this.permissionTips()) return

      const dataState = await checkDataStatus(this.type, this.item.no)
      if (!dataState) {
        this.$message.error("系统异常，请稍后再试")
        return
      }
      if (dataState != 1) {
        this.$emit("changeStatus", dataState)
        return
      }
      if (this.item.userNo === this.userNo||this.item.createUserNo=== this.userNo) {
        this.$message.error("操作失败，不能对自己发布的内容进行该操作")
        return
      }
      // else if (this.item.companyNo === this.companyNo) {
      //   this.$message.error("不能给自己发送函询！")
      //   return
      // }
      this.inByLetDialogShow = true
    },
    //提交函询表单
     async confirminDialog(obj) {
      if(this.type == 7){
        obj.markId = this.item.teamNo
      }else{
        obj.markId = this.item.no
      }
      obj.companyNo = this.item.companyNo ? this.item.companyNo : ""
      obj.markCreateNo = this.item.userNo
      if (this.type == 1) {
        obj.markName = this.item.teamName
        obj.title = `【${this.item.teamTypeName}】` + this.item.teamName
        obj.markType = 1
      } else if (this.type == 2) {
        obj.markName = this.item.name
        obj.title = "【工程公司】" + this.item.name
        obj.markType = 2
        obj.markCreateNo = this.item.createUser
      } else if (this.type == 3) {
        obj.markName = "专业工人"
        obj.title = "【专业工人】" + this.item.name
        obj.markType = 3
        obj.markCreateNo = this.item.userNo
      } else if (this.type == 4) {
        obj.markName = this.item.projectName
        obj.title = "【临时用工】" + this.item.projectName
        obj.markType = 4
        obj.markCreateNo = this.item.userNo
      } else if (this.type == 5) {
        obj.markName =this.item.categoryName.split("-").length>=3 ? this.item.categoryName.split("-")[2] : this.item.categoryName.split("-")[ this.item.categoryName.split("-").length-1]
        obj.title = "【工种报价】" + `${this.item.categoryName.split("-").length>=3 ? this.item.categoryName.split("-")[2] : this.item.categoryName.split("-")[ this.item.categoryName.split("-").length-1]}`
        obj.markType = 5
        obj.markCreateNo = this.item.userNo
      } else if (this.type == 6) {
        obj.markName = this.item.workName
        obj.title = "【劳务用工】" + this.item.workName
        obj.markType = 6
        obj.markCreateNo = this.item.createUserNo
      }else if (this.type == 7) {//班组找活函询绑定的工队
        obj.markName = this.item.teamName
        obj.title = "【班组工队】" + this.item.teamName
        obj.markType = 7
        obj.markCreateNo = this.item.userNo
      }
      let res = await apiResignAll.getaddEnquire(obj)
      if (res.data.code === 200) {
        this.$message.success("提交成功")
        this.inByLetDialogShow = false
      } else {
        this.$message.error("提交失败")
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
